import { ArrowForward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { TaxFormField } from "./TaxFormField";

export const TaxDetails = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <ArrowForward style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Details")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <TaxFormField label={t("Code")} type="text" code="Code" data={dataState} setData={setDataState} />
            <TaxFormField label={t("Description")} type="text" code="Description" data={dataState} setData={setDataState} />
            <TaxFormField label={`${t("Value")} (%)`} type="decimal" code="Value" data={dataState} setData={setDataState} />
          </div>
        }
      />

      
    </>
  )
}